import React from 'react';
import './input.css'; // Input specific styles

const Input = ({ placeholder, value, onChange, className }) => {
  return (
    <input
      className={`input ${className}`}
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};

export default Input;
